export const isCurrentOrigin = (targetUrl) => {
    try {
        return new URL(targetUrl).origin === window.location.origin;
    }
    catch {
        return false;
    }
};
//# sourceMappingURL=url.js.map